import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = {};

const marathonChallengeReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.GET_TOTAL_DEPOSITED_AMOUNT]: (state, action) => ({
        ...state,
        totalDepositedAmount: action.value,
    }),
});

export default marathonChallengeReducer;

